import { jsx, jsxs } from "react/jsx-runtime";
import { Button, Stack, Typography, useTheme } from "@mui/material";
function LoginCallToAction(props) {
  const { label, action, testId = "login-call-to-action-root", description, disabled = false } = props;
  const theme = useTheme();
  return /* @__PURE__ */ jsxs(Stack, { direction: "row", alignItems: "baseline", spacing: 1, "data-testid": testId, "data-tidal": "LoginCallToAction", children: [
    description ? /* @__PURE__ */ jsx(
      Typography,
      {
        sx: {
          fontWeight: theme.typography.fontWeightBold,
          color: (theme.vars ?? theme).palette.text.secondary
        },
        children: description
      }
    ) : null,
    /* @__PURE__ */ jsx(
      Button,
      {
        sx: {
          fontWeight: theme.typography.fontWeightBold
        },
        color: "primary",
        onClick: action,
        disabled,
        children: label
      }
    )
  ] });
}
export {
  LoginCallToAction
};
//# sourceMappingURL=LoginCallToAction.js.map
